import { render, staticRenderFns } from "./yunshanfuh5.vue?vue&type=template&id=506eaa62&scoped=true&"
import script from "./yunshanfuh5.vue?vue&type=script&lang=js&"
export * from "./yunshanfuh5.vue?vue&type=script&lang=js&"
import style0 from "./yunshanfuh5.vue?vue&type=style&index=0&id=506eaa62&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506eaa62",
  null
  
)

export default component.exports